export default "__VITE_ASSET__327f45bb__"